<template>
  <v-card>
    <v-container>
      <v-form v-model="broadcast_form" ref="broadcast_form">
        <span v-if="$props.broadcast_group">You are broadcasting to {{this.$props.broadcast_group.name }}</span>
        <v-textarea
            label="Broadcast Message"
            v-model="item.content"
            :rules="[rules.required]"
        />
        <v-text-field
            label="Push Notification Title"
            v-model="item.notification_text"
            :rules="[rules.required, rules.maxLength]"
        />
        <v-text-field
            label="Push Notification Body"
            v-model="item.notification_body"
            :rules="[rules.required, rules.bodyMaxLength]"
        />
        <v-file-input
          label="Select Message Image"
          v-model="file"
        />
      </v-form>
      <v-row class="ma-2">
        <img v-if="file_url" :src="file_url" alt="" style="width: 100px; height: 100px">
      </v-row>
      <v-card-actions>
        <v-row>
          <v-spacer/>
          <v-btn @click="$emit('close')">Cancel</v-btn>
          <v-btn v-if="!editing" color="success" @click="newBroadcast" :loading="loading">Create</v-btn>
          <v-btn v-else color="success" @click="editBroadcast" :loading="loading">Edit</v-btn>
        </v-row>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "BroadcastForm",
  props: {
    broadcast: {
      content: '',
      image_base64: '',
    },
    broadcast_group: Object,
    editing: Boolean
  },
  data() {
    return {
      broadcast_form: false,
      loading: false,
      item: {
        content: '',
        image_base64: '',
        created_by: this.$store.getters.user._id
      },
      file: '',
      file_url: '',
      rules: {
        required: v => !!v || 'Required Field',
        maxLength: v => (v && v.length < 30) || 'Max. 30 characters',
        bodyMaxLength: v => (v && v.length < 60) || 'Max. 60 characters',
      }
    }
  },
  methods: {
    async newBroadcast() {
      if (this.$refs.broadcast_form.validate()) {
        this.loading = !this.loading
        const formData = new FormData()
        this.item._id = this.$store.getters.user._id
        if (this.$props.broadcast_group) {
          this.item.broadcast_group = this.$props.broadcast_group._id
        }
        formData.append('image', this.file)
        formData.append('data', JSON.stringify(this.item))

        await this.$store.dispatch('NEW_BROADCAST', formData)
        this.loading = !this.loading
      }
    },
    async editBroadcast() {
      if (this.$refs.broadcast_form.validate()) {
        this.loading = !this.loading
        await this.$store.dispatch('UPDATE_BROADCAST', this.item)
        this.loading = !this.loading
      }
    }
  },
  computed: {
  },
  watch: {
    file(v) {
      this.file_url = URL.createObjectURL(v)
      const reader = new FileReader();
      const vm = this
      reader.readAsDataURL(v);
      // reader.onload = function () {
      //   vm.item.image_base64 = reader.result
      // };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      return v
    }
  },
  created() {
    if (this.$props.broadcast) {
      this.item = this.$props.broadcast
      fetch(this.item.image_base64)
      .then(res => res.blob())
      .then(res => {
          this.file_url = URL.createObjectURL(res)
      })
    }
  }
}
</script>

<style scoped>

</style>